import { useEffect } from "react";

import { useAuthValidate } from "features/auth/fabric";
import Auth from "areas/auth/ui/Auth";


export default function Confirm() {
	const auth = useAuthValidate();

	useEffect(() => {
		auth.redirect.confirm();
	}, [auth._]);

	return <Auth.Confirm />;
}